import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Select } from '../ui/Select';
import { TimePicker } from '../ui/TimePicker';
import { Input } from '../ui/Input';
import { MultiSelect } from '../ui/MultiSelect';
import { Schedule } from '../../types';
interface Step3Props {
  schedules: Schedule[];
  onChange: (schedules: Schedule[]) => void;
  trainers: Array<{
    value: string;
    label: string;
  }>;
}
export function Step3Schedule({
  schedules,
  onChange,
  trainers
}: Step3Props) {
  const addSchedule = () => {
    const newSchedule: Schedule = {
      id: Date.now().toString(),
      day: schedules.length + 1,
      startTime: '',
      endTime: '',
      subject: '',
      facilitators: []
    };
    onChange([...schedules, newSchedule]);
  };
  const updateSchedule = (id: string, field: keyof Schedule, value: any) => {
    onChange(schedules.map(s => s.id === id ? {
      ...s,
      [field]: value
    } : s));
  };
  const removeSchedule = (id: string) => {
    onChange(schedules.filter(s => s.id !== id));
  };
  const dayOptions = Array.from({
    length: 30
  }, (_, i) => ({
    value: (i + 1).toString(),
    label: `Day ${i + 1}`
  }));
  return <Card title="Training Schedule" data-id="element-74">
      <div className="space-y-4" data-id="element-75">
        {schedules.length === 0 ? <div className="text-center py-8 text-gray-500" data-id="element-76">
            No schedule added yet. Click "Add Session" to create one.
          </div> : schedules.map((schedule, index) => <div key={schedule.id} className="p-4 border border-gray-200 rounded-lg space-y-4" data-id="element-77">
              <div className="flex items-center justify-between" data-id="element-78">
                <h4 className="font-medium text-gray-900" data-id="element-79">
                  Session {index + 1}
                </h4>
                <button onClick={() => removeSchedule(schedule.id)} className="text-red-600 hover:text-red-800" title="Remove Session" data-id="element-80">
                  <Trash2 className="w-4 h-4" data-id="element-81" />
                </button>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-82">
                <Select label="Day" value={schedule.day.toString()} onChange={e => updateSchedule(schedule.id, 'day', parseInt(e.target.value))} options={dayOptions} required data-id="element-83" />

                <div className="grid grid-cols-2 gap-2" data-id="element-84">
                  <TimePicker label="Start Time" value={schedule.startTime} onChange={value => updateSchedule(schedule.id, 'startTime', value)} data-id="element-85" />
                  <TimePicker label="End Time" value={schedule.endTime} onChange={value => updateSchedule(schedule.id, 'endTime', value)} data-id="element-86" />
                </div>
              </div>

              <Input label="Subject" value={schedule.subject} onChange={e => updateSchedule(schedule.id, 'subject', e.target.value)} placeholder="Enter session topic or subject" required data-id="element-87" />

              <MultiSelect label="Facilitator(s)" options={trainers} value={schedule.facilitators} onChange={value => updateSchedule(schedule.id, 'facilitators', value)} placeholder="Select facilitators" data-id="element-88" />
            </div>)}

        <Button onClick={addSchedule} variant="secondary" className="w-full" data-id="element-89">
          <Plus className="w-4 h-4 mr-2" data-id="element-90" />
          Add Session
        </Button>
      </div>
    </Card>;
}